import MobilePage from "../../awrabet/utils/mobile-page";
export * from "../../awrabet/utils/mobile-page";
export default MobilePage;